// extracted by mini-css-extract-plugin
export default {"addToCollection":"oH-z"};